import {Component, Input, OnInit} from '@angular/core';
import {TYPE} from '../../models/type.enum';

@Component({
  selector: 'cmp-label',
  template: `<span class="badge badge-{{type}}">
  <ng-content></ng-content>
</span>
`,
  styles: [`.badge{font-weight:200;border-radius:2px}`]
})
export class LabelComponent implements OnInit {

  @Input() type = TYPE;

  constructor() {
  }

  ngOnInit() {
  }

}
